import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { ForgeApiService } from '../services/ForgeApiService';

interface RecognitionAdminAccessContextValue {
  hasRecognitionAdminAccess: boolean | null;
}

const RecognitionAdminAccessContext = createContext<RecognitionAdminAccessContextValue>({
  hasRecognitionAdminAccess: null,
});

export const RecognitionAdminAccessProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { token } = useAuthContext();
  const [hasRecognitionAdminAccess, setHasRecognitionAdminAccess] = useState<boolean | null>(null);

  useEffect(() => {
    if (!token) {
      setHasRecognitionAdminAccess(false);
      return undefined;
    }

    let active = true;
    setHasRecognitionAdminAccess(null);
    void ForgeApiService.fetchRecognitionReviewAccess(token)
      .then((response) => {
        if (active) setHasRecognitionAdminAccess(response.hasAccess);
      })
      .catch(() => {
        if (active) setHasRecognitionAdminAccess(false);
      });

    return () => {
      active = false;
    };
  }, [token]);

  return (
    <RecognitionAdminAccessContext.Provider value={{ hasRecognitionAdminAccess }}>
      {children}
    </RecognitionAdminAccessContext.Provider>
  );
};

export function useRecognitionAdminAccess(): RecognitionAdminAccessContextValue {
  return useContext(RecognitionAdminAccessContext);
}
